import React from 'react';
import './UploadingModal.css';

interface UploadingModalProps {
  isOpen: boolean;
  message?: string;
}

const UploadingModal: React.FC<UploadingModalProps> = ({
  isOpen,
  message = 'Uploading...'
}) => {
  if (!isOpen) return null;

  return (
    <div className="uploading-modal-backdrop">
      <div className="uploading-modal">
        <div className="uploading-spinner">
          <div className="spinner-ring"></div>
        </div>
        <div className="uploading-message">{message}</div>
      </div>
    </div>
  );
};

export default UploadingModal;
